<div class="agpr-wireCompositionReport">
    <agpr-shadow-dom-container
        *ngIf="companyLogoHtml"
        [customHtml]="companyLogoHtml"
    ></agpr-shadow-dom-container>
    <div class="agpr-wireCompositionReport-headerLogoContainer">
        <div class="agpr-wireCompositionReport-headerContainer">
            <agpr-shadow-dom-container [customHtml]="headerHtml"></agpr-shadow-dom-container>
        </div>
        <div class="agpr-wireCompositionReport-logoContainer">
            <agpr-shadow-dom-container [customHtml]="logoHtml"></agpr-shadow-dom-container>
        </div>
    </div>
    <agpr-scroll-panel class="agpr-compositionReport-scrollPanel">
        <agpr-shadow-dom-container [customHtml]="bodyHtml"></agpr-shadow-dom-container>
    </agpr-scroll-panel>
</div>
